import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
	name: 'StockCorrectionReport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			// totalRows:0,
			listStockCorectionReportData: [],
			listStockCorrectionReportDataCsv: [],
			csvFields: [],
			// pageLimit: 10,
			// pageno: 0,
			// totalPage: 0,
			POID: '',
			fromdate: '',
			todate: '',
			isLoading: false,
			formattedDate: '',
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			toracktype: '',
			stocktypeErr: '',
			stockcorrectiontype: '',
			productid: '',
			rackid: '',
			fromdateErr: '',
			todateErr: '',
			stockcorrectiontypeErr: '',
			recordLimit: 0,
			limitExeed: false,
			userid: '',
			listMerchantData:[],
			MerchantList: [],
			merchantid: '',
			merchant: '',
			item:{},
		    listMerchantData1:[],
		    merchantList:[]
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY hh:mm:ss');
		}
	},
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.userid = userdetail.userid;
		this.reportname = this.$t('stockCorrectionReport.stockCorrectionReportFile');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		//this.getStockCorrectionReportData();
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined'){
			this.getMerchantList();
        }


		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error($t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit();
		this.calldateFunction();
	},
	methods: {
		calldateFunction() {
			//console.log("sagar")
            this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
            this.todate = this.currentDate;
            var dt = new Date(this.currentDate);
            dt.setDate(dt.getDate() - 6);
            this.fromdate = dt;
			console.log(this.fromdate)
        },
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getStockCorrectionReportDataFOrXls(3)
			}
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.getMerchantList();
		// 		this.merchant='';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			// this.getStockCorrectionReportData();
		// 		}
		// 	}
		// 	this.listStockCorectionReportData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getStockCorrectionReportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		getStockCorrectionReportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getStockCorrectionReportData(2);
		},
		//to get client list
		getStockCorrectionReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			this.searchFlag = true;
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listStockCorectionReportData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listStockCorectionReportData = [];
				return false;
			}
			if (this.stockcorrectiontype == '') {
				this.stockcorrectiontypeErr = this.$t('auditReport.stockCorrectionTypeError');
				this.pageNo = this.totalPage = 0;
				this.listStockCorectionReportData = [];
				return false;
			}
			if (this.fromdate == '') {
				this.fromdateErr = this.$t('stockCorrectionReport.transferFromDateErr');
				this.pageNo = this.totalPage = 0;
				this.listStockCorectionReportData = [];
				return false;
			}
			if (this.todate == '') {
				this.todateErr = this.$t('stockCorrectionReport.transferToDateErr');
				this.pageNo = this.totalPage = 0;
				this.listStockCorectionReportData = [];
				return false;
			}

			this.isLoading = true;
			if (this.fromdate) {
				fr_date = this.dateFormat1(this.fromdate)
			}
			if (this.todate) {
				to_date = this.dateFormat2(this.todate)
			}
			if (csvCheck == 2)
				this.pageno = 0;

			this.input = ({
				'clientid': this.clientid,
				'warehouseid': window.localStorage.getItem('selectedWarehouse'),
				'rackid': this.rackid.trim(),
				'productid': this.productid.trim(),
				'fromdate': fr_date,
				'todate': to_date,
				'stockcorrectiontype': this.stockcorrectiontype,
				'offset': (this.currentPage - 1) * 10,
				'limit': this.pageLimit,
				'csvData': csvCheck,
				'userid': this.userid,
				'merchantid':this.merchant
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'stockCorrectionreport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.listStockCorrectionReportDataCsv = [];
							this.csvFields = {
								'stockcorrectiontype': this.$t('auditReport.stockCorrectionType'),
								'rackid': this.$t('common.rackID'),
								'productid': this.$t('common.productId'),
								'eancode': this.$t('stockCorrectionReport.productEAN'),
								'mrp': this.$t('stockTransfer.productMrp'),
								'txnqty': this.$t('stockCorrectionReport.correctionQty'),
								'createddatetime': this.$t('stockCorrectionReport.correctionDate'),
								'txnuser': this.$t('stockCorrectionReport.correctionBy'),
								'reason': this.$t('auditReport.correctionReason'),
								'comment': this.$t('inwardList.printData.comments'),
								'whcurrentstock': this.$t('stockCorrectionReport.correctionBy'),
								'whrackstock': this.$t('stockCorrectionReport.rackRS'),
								'merchantname': this.$t('common.merchantName'),
							};
							var dateFilter = [];
							var skipFilter = [];
							this.listStockCorrectionReportDataCsv = result.data.data;
							csvHelper.data.jsonToCSV(this.$t('stockCorrectionReport.stockCorrectionReportFile'), this.listStockCorrectionReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('StockCorrectionReport', this.listStockCorrectionReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success($t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listStockCorectionReportData = result.data.data;
						if (result.data.errorCode == -1) {
							this.resultCount = 0;
							this.totalRows = 0;
						} else {
							this.totalRows = result.data.count;
							this.resultCount = result.data.count;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						}
					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getStockCorrectionReportDataFOrXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			this.searchFlag = true;
			// this.ClientErr = '';


			if (this.fromdate) {
				fr_date = this.dateFormat1(this.fromdate)
			}
			if (this.todate) {
				to_date = this.dateFormat2(this.todate)
			}
			if (csvCheck == 2)
				this.pageno = 0;

			this.input = ({
				'clientid': this.clientid,
				'warehouseid': window.localStorage.getItem('selectedWarehouse'),
				'rackid': this.rackid.trim(),
				'productid': this.productid.trim(),
				'fromdate': fr_date,
				'todate': to_date,
				'stockcorrectiontype': this.stockcorrectiontype,
				'offset': (this.currentPage - 1) * 10,
				'limit': this.pageLimit,
				'csvData': csvCheck,
				'userid': this.userid,
				'merchantid':this.merchant,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'stockCorrectionreport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls[this.$t('auditReport.stockCorrectionType')]='stockcorrectiontype';
							this.csvFieldsForXls[this.$t('common.rackID')]='rackid';
							this.csvFieldsForXls[this.$t('common.productId')]='productid';
							this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname';
							this.csvFieldsForXls[this.$t('stockCorrectionReport.productEAN')]='eancode';
							this.csvFieldsForXls[this.$t('stockTransfer.productMrp')]='mrp';
							this.csvFieldsForXls[this.$t('stockCorrectionReport.correctionQty')]='txnqty';
							this.csvFieldsForXls[this.$t('stockCorrectionReport.correctionDate')]='createddatetime';
							this.csvFieldsForXls[this.$t('stockCorrectionReport.correctionBy')]='txnuser';
							this.csvFieldsForXls[this.$t('auditReport.correctionReason')]='reason';
							this.csvFieldsForXls[this.$t('inwardList.printData.comments')]='comment';
							this.csvFieldsForXls[this.$t('stockCorrectionReport.correctionBy')]='whcurrentstock';

							this.listReportDataforxls = result.data.data;
						} else {
							if (result.data.status == true) {
								this.$alertify.success($t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


				}, error => {
					console.error(error);
				})
		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.pageLimit;
		// 	this.getStockCorrectionReportData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getStockCorrectionReportData()
		},

		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.show = false;
			this.download = true;
			this.fromdate = '';
			this.todate = '';
			this.rackid = '';
			this.merchant='';
			this.stockcorrectiontype = '';
			this.fromdateErr = '';
			this.todateErr = '';
			this.stockcorrectiontypeErr = '';
			this.productid = '';
			this.pageno = 0;
			this.merchant='';
			this.totalRows = 0;
			this.searchFlag = false;
			this.listStockCorectionReportData = [];
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
			this.item={
				value:'',
				text:''
			};
			// this.listMerchantData1=[{value:'',text: this.$t('common.selectMerchantPlaceHolder')}];
			//this.getStockCorrectionReportData();
		},
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
                       this.item={
						   value:'',
						   text:''
					   };
						this.listMerchantData1=[{value:'',text: this.$t('common.selectMerchantPlaceHolder')}];
					    this.listMerchantData.forEach(ele=>{
						this.listMerchantData1.push({
							"value":ele.merchantid,
							"text":ele.merchantname
						})
					   }) 
					}  
				}, error => {
					console.error(error)
				})
		},
		reset(){
			this.item={}
		},
		onSelect(item){
			this.item=item
			this.merchant=item.value
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/reports/stockcorrectionreport/stockcorrectionreport.component.js